var _excluded = ["bounds", "boundsOptions", "center", "children", "className", "id", "placeholder", "style", "whenReady", "zoom"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { LeafletProvider, createLeafletContext } from '@react-leaflet/core';
import { Map as LeafletMap } from 'leaflet';
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from 'react';
function MapContainerComponent(_ref, forwardedRef) {
  var bounds = _ref.bounds,
    boundsOptions = _ref.boundsOptions,
    center = _ref.center,
    children = _ref.children,
    className = _ref.className,
    id = _ref.id,
    placeholder = _ref.placeholder,
    style = _ref.style,
    whenReady = _ref.whenReady,
    zoom = _ref.zoom,
    options = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState({
      className: className,
      id: id,
      style: style
    }),
    _useState2 = _slicedToArray(_useState, 1),
    props = _useState2[0];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    context = _useState4[0],
    setContext = _useState4[1];
  useImperativeHandle(forwardedRef, function () {
    var _context$map;
    return (_context$map = context === null || context === void 0 ? void 0 : context.map) !== null && _context$map !== void 0 ? _context$map : null;
  }, [context]);
  var mapRef = useCallback(function (node) {
    if (node !== null && context === null) {
      var map = new LeafletMap(node, options);
      if (center != null && zoom != null) {
        map.setView(center, zoom);
      } else if (bounds != null) {
        map.fitBounds(bounds, boundsOptions);
      }
      if (whenReady != null) {
        map.whenReady(whenReady);
      }
      setContext(createLeafletContext(map));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    return function () {
      context === null || context === void 0 || context.map.remove();
    };
  }, [context]);
  var contents = context ? /*#__PURE__*/React.createElement(LeafletProvider, {
    value: context
  }, children) : placeholder !== null && placeholder !== void 0 ? placeholder : null;
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    ref: mapRef
  }), contents);
}
export var MapContainer = /*#__PURE__*/forwardRef(MapContainerComponent);